import React from 'react';

const Beyond = () => {
  return (
    <section id="beyond" className="section">
      <div className="stack">
        <h2>Beyond Code</h2>

        <p className="text-muted">
          Creation doesn’t stop at software.
          Some things I do to stay grounded and curious.
        </p>

        <div className="divider" />

        <div className="stack">
          <p>
            I ride to clear my head.
            Long roads, changing weather, and silence help me think without forcing answers.
          </p>

          <p>
            I paint and create when logic reaches its limits.
            Art teaches patience, observation, and acceptance of imperfection.
          </p>

          <p>
            Movement keeps me honest.
            It reminds me that progress — in code or life —
            comes from consistency, not intensity.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Beyond;
